import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import fields from '../../lib/fields';

import FormFieldsCompact from '../form/fieldsCompact';

const FACTBOX_FIELDS = ['title', 'body', 'factSource', 'active'];

@observer
class EditFactbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('article', ['Article basics']),
        };
    }

    componentDidMount() {
        const { id } = this.props;
        const { articleStore } = this.props.stores;
        articleStore.loadFactboxForEdit(parseInt(id, 10));
    }

    onClickDone = () => {
        const { callback = () => {}, drawerLevel = 1 } = this.props;
        const { appState } = this.props.stores;
        callback();
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { drawerLevel } = this.props;
        const { sections } = this.state;
        const { articleStore } = this.props.stores;
        const { factboxArticle } = articleStore;

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <h5 class='ms-3 mb-3'>
                        <i class='fa-solid fa-lightbulb me-2' />
                        <Text id='article.editFactbox'>Edit factbox</Text>
                        {factboxArticle?.id > 0 && <small class='text-body-secondary ms-2'>{`{{factbox.${factboxArticle.id}}}`}</small>}
                    </h5>
                    {factboxArticle?.id > 0 ? <>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFieldsCompact
                                stores={this.props.stores}
                                sections={sections}
                                fields={FACTBOX_FIELDS}
                                holdingStore={articleStore}
                                objectName='factboxArticle'
                                isNew={false}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                hideFilterToolbar={true}
                            />
                        </div>
                        <div class='d-flex flex-column align-items-center mt-3'>
                            <small class='text-body-secondary mb-2'>
                                <Text id='article.autoSaveInfo'>Changes are saved automatically.</Text>
                            </small>
                            <button type='button' class='btn btn-primary rounded-pill px-5' onClick={this.onClickDone}>
                                <Text id='article.done'>Done</Text>
                            </button>
                        </div>
                    </> : <div class='text-center text-body-secondary py-5'>
                        <span class='spinner-border spinner-border-sm me-2' />
                        <Text id='article.loadingFactbox'>Loading factbox...</Text>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default EditFactbox;
